import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import android from './android.png';
import ios from './ios.png';

const Container = styled.div`
  padding: ${props => props.theme.spacing(6)}px;
`;

const Badge = styled.img`
  height: 40px;
  width: 135px;
`;

export default function InstallCustomerApp() {
  return (
    <div>
      <Grid container component={Container} direction="column" spacing={4}>
        <Grid item>
          <Typography variant="h1">Rengastalli mobiilisovellus</Typography>
        </Grid>

        <Grid item>
          <Typography color="textSecondary" gutterBottom>
            Lataa mobiilisovellus puhelimeesi alla olevasta napista.
          </Typography>

          <Typography color="textSecondary" gutterBottom>
            Käyttäjätunnus sovellukseen on sähköpostiosoitteesi.
          </Typography>
        </Grid>

        <Grid item>
          <Grid container spacing={1} wrap="wrap" justify="space-evenly">
            <Grid item>
              <a href="https://play.google.com/store/apps/details?id=fi.vantage.tires_online">
                <Badge alt="Lataa Google Play kaupasta" src={android} />
              </a>
            </Grid>

            <Grid item>
              <a href="https://apps.apple.com/fi/app/rengastalli/id1476681468?mt=8">
                <Badge alt="Lataa App Storesta" src={ios} />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
